// extracted by mini-css-extract-plugin
export default {"container":"OnBoardingPageB_container__yVhnI","form-input":"OnBoardingPageB_form-input__6A7M6","prefix":"OnBoardingPageB_prefix__cLyyF"};